import React, { FC } from 'react';

import { graphql } from 'gatsby';

import { PageTemplateProps } from 'types/types';
import ConsiderationBase from 'base-templates/consideration-base';

const Consideration: FC<PageTemplateProps> = (props) => {
  return (
    <ConsiderationBase defaultProps={props} />
  );
};

export default Consideration;

export const query = graphql`
  query($nid: String!, $LanguageId: Drupal_LanguageId!, $i18nKey: String!) {
    capterra: allFile(
      filter: {
        sourceInstanceName: { eq: "consideration_" }
        extension: { eq: "png" }
      }
    ) {
      edges {
        node {
          childImageSharp {
            gatsbyImageData(width: 600, quality: 100, layout: CONSTRAINED)
          }
          relativePath
          relativeDirectory
        }
      }
    }
    drupal {
      nodeReference: nodeById(id: "4314", language: $LanguageId) {
        entityUrl {
          path
        }
      }
      nodeById(id: $nid, language: $LanguageId) {
        ... on Drupal_NodeConsideration {
          ...entityFields
          fieldExtraTranslations {
            entity {
              ...extraTranslations
            }
          }
          fieldGenerationType {
            entity {
              entityId
            }
          }
          fieldConsiderationTitle
          fieldConsiderationTitlePiece
          fieldHeaderImage {
            entity {
              ... on Drupal_ParagraphSeoImage {
                fieldImageLink
                fieldAltText
              }
            }
          }
          fieldMakeADiagram {
            entity {
              entityTranslation(language: $LanguageId) {
                ... on Drupal_TaxonomyTermMakeANDiagram {
                  name
                }
              }
            }
          }
          fieldConsiderationPaperTitle
          fieldConsiderationFeatureSect {
            entity {
              ... on Drupal_ParagraphConsiderationSection {
                fieldContentSectionHeading
                fieldConsiderationDescription {
                  processed
                }
                fieldContentSectionImageLink
                fieldConsFeatureSectAlt
              }
            }
          }
          fieldConsiderationSocialLink {
            entity {
              entityUrl {
                path
              }
            }
          }
          fieldConsiderationStepsTitle
          fieldConsiderationStepItem {
            entity {
              ... on Drupal_ParagraphSteps {
                fieldStepNumber
                fieldStepTitle
                fieldStepDescription
              }
            }
          }
          fieldConsiderationStepsButton
          fieldConsiderationFaqTitle
          fieldConsiderationFaqItems {
            entity {
              ... on Drupal_ParagraphFaqItems {
                fieldFaqHeader
                fieldFaqItemDescription
                fieldLearnMoreLink
              }
            }
          }
          fieldConsiderationVideoTitle
          fieldConsiderationVideoImage {
            entity {
              ... on Drupal_ParagraphSeoImage {
                fieldImageLink
                fieldAltText
              }
            }
          }
          fieldConsiderationVideoLink
          fieldConsiderationVideoDescri
          fieldConsiderationVideoDurati
          fieldConsiderationVideoUpload {
            date
          }
          fieldConsiderationQuote
          fieldConsiderationTemplateHea
          fieldCards {
            entity {
              ... on Drupal_ParagraphConsiderationCards {
                fieldAltText
                fieldCardHeader
                fieldImage
                fieldLink
              }
            }
          }
          fieldPersona {
            entity {
              entityLabel
            }
          }
          fieldDiagramType {
            entity {
              entityLabel
            }
          }
        }
      }
    }
    i18nData: allFile(
      filter: {
        sourceInstanceName: { eq: "i18n" }
        name: { in: [$i18nKey, "en"] }
      }
    ) {
      edges {
        node {
          name
          childSrcJson {
            mktg_ct_consideration_footer_header
            mktg_ct_consideration_socialproof_header
            mktg_ct_consideration_video_cta
            mktg_ct_consideration_socialproof_review_stats
            mktg_ct_consideration_faq_link_text
            mktg_ct_consideration_socialproof_link
            mktg_email_only_or_sign_up_with
            mktg_bounce_detection_header
            mktg_bounce_detection_p1
            mktg_email_only_make_a_diagram_default
            mktg_consideration_see_why
            mktg_learn_more
            mktg_abtest_brandMessagingConsideration
          }
        }
      }
    }
  }
`;
